function Icon({width=17, height=20, fill="#1C1B1F"}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 17 20"
    >
      <path
        fill={fill}
        d="M15.94 19.021c-1.884 0-3.777-.487-5.68-1.462-1.901-.975-3.649-2.35-5.242-4.126-1.593-1.775-2.827-3.72-3.704-5.832C.438 5.49 0 3.385 0 1.288 0 .951.1.671.3.446.5.222.75.11 1.05.11h3.261c.253 0 .476.092.669.275.193.184.315.41.368.68l.573 3.273c.04.303.032.564-.025.783a1.192 1.192 0 01-.304.55l-2.31 2.5a15.68 15.68 0 001.275 2.15c.477.675.994 1.32 1.55 1.934a17.538 17.538 0 003.752 3.162l2.245-2.517c.156-.181.346-.309.568-.381.223-.073.454-.09.694-.054l2.776.63c.253.073.459.217.619.43.16.212.239.453.239.722v3.607c0 .334-.1.612-.303.835a.98.98 0 01-.757.333zM2.573 6.591l1.785-1.9a.204.204 0 00.062-.117.288.288 0 00-.005-.139L3.981 1.95a.236.236 0 00-.067-.128.18.18 0 00-.126-.043H1.65a.124.124 0 00-.096.043.155.155 0 00-.038.107c.05.76.163 1.532.335 2.317.172.784.413 1.567.722 2.347zm8.7 9.615a9.601 9.601 0 002.074.788c.72.182 1.393.29 2.018.324.039 0 .07-.014.096-.042a.154.154 0 00.039-.107v-2.34a.232.232 0 00-.039-.14.204.204 0 00-.115-.075l-2.1-.475a.142.142 0 00-.1-.005.247.247 0 00-.092.07l-1.781 2.002z"
      ></path>
    </svg>
  );
}

export default Icon;
